import { useAuthData } from '@auth/features/auth';
import { useIncidentDrawerStore } from '@incidents/entities/incident';
import { TriangleAlert } from 'lucide-react';
import { Button, Tooltip } from '@/shared/ui';
import { IncidentCountBadge } from './incident-count-badge';
import css from './incident-drawer-trigger.module.scss';

type IncidentDrawerTriggerProps = {
  className?: string;
  label?: string;
};

// Header trigger, sitting next to "My tasks". Opens the "My incidents"
// slide-over. Only rendered for roles that can report incidents
// (incidents:create) — Finance and no-access roles never mount it, so its
// count query never fires for them.
export const IncidentDrawerTrigger = ({
  className,
  label = 'Incidents',
}: IncidentDrawerTriggerProps) => {
  const openDrawer = useIncidentDrawerStore((s) => s.openDrawer);
  const { data: authData } = useAuthData();
  const canReport =
    authData?.user.permissions.includes('incidents:create') ?? false;

  if (!canReport) return null;

  return (
    <Tooltip content={label} position="bottom">
      <div className={css.root}>
        <Button
          aria-label={label}
          className={className}
          icon={<TriangleAlert className={css.icon} />}
          onClick={openDrawer}
          size="icon"
          variant="ghost"
        />
        <span className={css.badgeAnchor}>
          <IncidentCountBadge />
        </span>
      </div>
    </Tooltip>
  );
};
